import dayjs from "dayjs";
import { FC } from "react";
import Select from "shared/Select/Select";


export const SelectHours: FC<any> = (props) => {
	let tmpDate = dayjs().set("hour", 6).set("minutes", 0);

	const options = [];

	while (tmpDate.get("hours") < 21) {
		options.push(tmpDate.format("HH:mm"));
		tmpDate = tmpDate.add(props.minuteStep || 30, "minutes");
	}

	return (
		<Select {...props}>
			<option value=""></option>
			{options.map((o: string, index: number) => (
				<option value={o} key={index}>
					{o}
				</option>
			))}
		</Select>
	);
};
